import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../../../types/common/types';

export const templateDownloadTypeForm = document.createElement('template');

templateDownloadTypeForm.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div id='staging-details-form-wrapper'>
    <gz-title fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle' id='details-subtitle'></gz-title>
    <div class='form-section'>
      <gz-form-field id='download-type-form-field' class='label-mw-250' label=''>
        <gz-dropdown gz-form-input localFiltering combobox type='dropdown'></gz-dropdown>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>
  </div>
`;
